import {createReducer} from '@reduxjs/toolkit'
import {IUser} from '@wix/yoshi-flow-editor'
import {setCurrentUser} from '../actions/current-user'

const defaultState: Partial<IUser> = {
  id: null,
  role: null,
  loggedIn: false,
}

export const currentUser = createReducer(defaultState, builder => {
  builder.addCase(setCurrentUser, (_state, action) => action.payload)
})
